












import { Component, Prop, Vue } from 'vue-property-decorator'
import Header from '@/components/Header.vue' // @ is an alias to /src
import Footer from '@/components/Footer.vue'

@Component({
    components: {
        Header,
        Footer,
    },
})
export default class IndexTheme extends Vue {}
